import { Button, Container, CssBaseline, Theme, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useContext } from 'react';

import { useI18n } from '../../../application/language/useI18n';
import { Colors } from '../../../view/design/color/Colors';
import { MainLayoutBottomLogoMenu } from '../../../view/layout/main/parts/LeftNavigation/parts/MainLayoutBottomLogoMenu';
import { ErrorPageOrganization } from '../../../view/layout/main/parts/LeftNavigation/parts/MainLayoutLeftNavigationTopLogo';
import { ContainerContext } from '../../container/ContainerContext';

const NotFoundErrorPage = () => {
  const context = useContext(ContainerContext);
  const ReqEduLogoComponent = context.get(MainLayoutBottomLogoMenu);
  const ErrorPageOrganizationContent = context.get(ErrorPageOrganization);
  const classes = useStyles();
  const { translate, getCurrentLanguage } = useI18n();

  return (
    <>
      <CssBaseline />
      <Container disableGutters maxWidth={false}>
        <Typography className={classes.background}>
          <Typography className={classes.topIcons} style={{ width: getCurrentLanguage() === 'ru' ? '220px' : '370px' }}>
            <ReqEduLogoComponent />
          </Typography>

          <Typography>
            <img src="/pictures/404.png" />
          </Typography>

          <Typography variant="h3" className={classes.headlineText}>
            {translate('404Page.title')}
          </Typography>

          <Typography variant="h6" className={classes.mainText}>
            {translate('404Page.message')}
          </Typography>

          <Button
            size="large"
            color="primary"
            className={classes.redirectButton}
            variant="contained"
            onClick={() => {
              window.location.href = `/project/all`;
            }}
          >
            {translate('404Page.button')}
          </Button>

          <Typography variant="body2" className={classes.footerText}>
            {ErrorPageOrganizationContent(getCurrentLanguage())} {new Date().getFullYear()}
          </Typography>
        </Typography>
      </Container>
    </>
  );
};

export default NotFoundErrorPage;

const useStyles = makeStyles((theme: Theme) => ({
  background: {
    margin: '0',
    padding: '20px 0',
    background: `${Colors.bg} !important`,
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  redirectButton: {
    background: Colors.btnAccent,
    color: Colors.textOnPrimary,
    '&:hover': {
      background: Colors.btnAccentHover,
    },
  },
  topIcons: {
    paddingTop: '20px',
    paddingBottom: '30px',
  },
  mainText: {
    width: '480px',
    color: Colors.textPrimary,
    textAlign: 'center',
    paddingBottom: '20px',
  },
  headlineText: {
    color: Colors.textPrimary,
    fontWeight: 'bold',
    fontSize: '48px',
    textAlign: 'center',
    paddingTop: '20px',
    paddingBottom: '10px',
  },
  footerText: {
    color: Colors.textDisabled,
    fontSize: '12px',
    fontWeight: '200',
    marginTop: 'auto',
    paddingTop: '20px',
  },
}));
